import {BasicReviewForm} from './basicReviewForm';
import {reCaptcha} from "../../components/reCaptcha/reCaptcha";

import './scss/basicContactForm.scss';

const BasicContactForm = function () {
	let _this = this;
	let form = $('#contact-form');
	let formJS = document.querySelector('#contact-form');
	this.id = 'contactEnquiry';
	$('.zero').val(1);
	
	this.validate = () => {
		//console.log('validating');
	};
	
	this.send = form => {
		
		let send = $.ajax({
			type: 'POST',
			url: form.attr('action') + '&rand=' + Math.random(),
			data: form.serialize()
		});
		
		send.done(response => {
			let data = $.parseJSON(response);
			// spinner.remove();
			
			form.find('.form-info').fadeIn().empty().append('<p>' + data.contents + '</p>').addClass(data.status);
			
			if (data.status === 'ok') {
				form.find("input[type='text'], input[type='email'], textarea").val('');
				
				//Set default phone value: UNUSED
				form.find('[data-default]').each(function () {
					form.val(form.data('default'));
				});
				
				if (data.token != undefined) {
					form.find('.js-csrf').val(data.token);
				}
				
				//Zwrotny KOD np youlead do przepisania
				/* if (data.code != null && data.code !== undefined) {
					 let s = document.createElement('script');
					 s.type = 'text/javascript';
					 try {
						 s.appendChild(document.createTextNode(data.code));
						 document.body.appendChild(s);
					 } catch (e) {
						 s.text = code;
						 document.body.appendChild(s);
					 }
				 }*/
			} else {
				if (data.fields !== undefined) {
					$('.form-info').fadeIn();
					for (let i = 0; i <= (data.fields).length; i++) {
						form.find(".formField" + data.fields[i]).addClass('error');
					}
				}
			}
		});
		
	};
	
	form.submit(function (e) {
		e.preventDefault();
		//spinner.show(form, '#1d3557');
		setTimeout(function () {
			$('input, textarea').removeClass('error').removeClass('ok');
			$('.form-info').fadeOut();
		}, 4500);
		
		new reCaptcha('#contact-form').then(token => {
				formJS.querySelector('[name="g-recaptcha-response"]').value = token;
				_this.send(form);
			})
			.catch(err => {
				console.error(err);
			});
	});
	
	
	/*	this.handleSubmit = () => {
			$('.contactFormular__button').click((e) => {
				e.preventDefault();
				//_this.validate();
				_this.send();
			});
		};*/
	
	/*this.handleSubmit();*/
	
};


export {BasicContactForm};



// WEBPACK FOOTER //
// ../components/basicContactForm/basicContactForm.js